<template>
  <div class="homeleft">
    <div class="listai">
      <h1>
        《起名废急救指南》 第二章 第二节 从古人的字学起名
      </h1>
      <Row justify="center" class="titleTime">
        <Col class="titleName" :xs="12" :sm="12" :md="12" :lg="12">作者：姓名图谱官方</Col>
        <Col class="titleName" :xs="12" :sm="12" :md="12" :lg="12">时间：2020年1月8日</Col>
      </Row>
      <p></p>
      <p>从上一篇我们分析了姓和氏的起源及其不同，到最后演变为姓氏的统一，本章我们再来看看另外一个和姓名相关的话题：古人的名、字、号。并从这些名字号中汲取灵感，为我们起名之用。</p>
      <p>和我们通常说的名字不同，古人的名、字是完全不同的概念。《說文》中对“名”这个字的解释是：“自命也。从口从夕。夕者，冥也。冥不相見，故以口自名。”就是说，“名”这个字是给自己命名，由口和夕构成。夕就是晚上。晚上大家无法看到对方，就只能用嘴喊了。可见，“名”就是为了互相区分而指定的代号。</p>
      <div class="contentImg">
        <img src="@/assets/article41.jpg" />
      </div>
      <p>在古代，父母称呼未成年人的就是“名”，类似我们现在的小名，用于非正式的家庭场合。子女成年后就要更换一个更正式的称谓，就是“字”。“字”相当于我们现今的名字。据《礼记·内则》记载，孩子出生后三个月父亲要为其取名。那么古人为孩子取名有哪些讲究呢？</p>
      <div class="contentImg">
        <img src="@/assets/article42.jpg" />
      </div>
      <p>鲁桓公六年九月，其夫人文姜生下长子姬同（后来的鲁庄公），鲁国为此举行了隆重的祭祀和庆祝仪式。在行礼之前，桓公向博学的申繻请教给自己的嫡长子，未来的鲁国国君取什么名字。申繻答曰：“名有五，有信，有义，有象，有假，有类。以名生为信，以德命为义，以类命为象，取于物为假，取于父为类。不以国，不以官，不以山川，不以隐疾，不以畜牲，不以器币。周人以讳事神，名，终将讳之。故以国则废名，以官则废职，以山川则废主，以畜牲则废祀，以器币则废礼。晋以僖侯废司徒，宋以武公废司空，先君献，武废二山，是以大物不可以命”。公曰 ：“是其生也，与吾同物，命之曰同 。”</p>
    
      <h4>“信”就是根据孩子的生理特征进行取名。比如身上的胎记，手掌的特殊纹路。</h4>
      <h4>“义”就是用有美化内涵的字来取名。</h4>
      <h4>“象”就是类比，和某物类似，就以某物的特点取名。如孔子名丘，据说是因为“生而首上于顶”（史记 孔子世家），脑门比较高相关土丘，故名之曰丘。</h4>
      <h4>“假”指用相关的物品来命名。</h4>
      <h4>“类”即使用和父辈类似的名字。</h4>
      <h4>另外，取名还不能取国家、官职、山川、隐疾、牲畜、器币相同的名字。</h4>
      <div class="contentImg">
        <img src="@/assets/article43.jpg" />
      </div>
      <p>随着孩子成年，就要取一个更正式的字了。《礼记〃檀弓》说：“幼名，冠字，五十以伯仲，死谥，周道也”。人幼时取名，到了弱冠之年（20岁）取字，又称“表字”，以利社会交往。《仪礼·士冠礼》：“冠而字之，敬其名也。”是说成年后，只有君父才能称其名，他人则称字也。</p>
      <p>字，也称为表字。《颜氏家训·风操》：“古者，名以正体，字以表德。”字通常都和名有一定的联系：</p>
      <p>吉常宏老师在《中国人的名字别号》中将其归为12种：</p>
      <p>(1) 同义相协：即名与字为同义词，二者相为辅佐，互作解释。</p>
      <p> 端木赐，字子贡。《尔雅·释诂》：“贡，赐也。” 魏延，字文长。《尔雅·释诂》：“延，长也。”</p>
      <p>(2) 反义相应：名与字为反义词，二者对立相应，各从反面作解。</p>
      <p>韩愈，字退之。愈为胜过，退之则是约束使勿胜过。</p>
      <p>(3) 连类相及：义类相近或相似，遂因甲而及乙。</p>
      <p>况钟，字伯律。钟为乐器，自然就要有音律。李渔，字笠翁渔和笠相关。《笠翁对韵》是蒙学经典之一。</p>
      <p>(4) 因性指实：由于汉语的字很多都是多义字，名具体指什么就可以用字来进一步解释其义项。</p>
      <p> 然丹，字子革。古人制皮革时以丹或漆涂抹，因此“丹”为红色涂料。井丹，字大春。大春为长寿之义，因此“丹”为丹药。</p>
      <p>(5) 辨物统类：就名所代表之物品，加以辨别，以说明其种属关系。</p>
      <p>孔鲤，字伯鱼。</p>
      <p>(6) 景仰前贤</p>
      <p>司马相如，字长卿。因仰慕战国时期赵国大将蔺相如而取名相如，又因蔺相如为“上卿”，故以“长卿”为字。</p>
      <p>(7) 记实志盛</p>
      <p>名字记录某个事件。鲁国庄公与其父桓公生日相同，遂名同生。</p>
      <p>(8) 概括经义</p>
      <p>从经典名句中概括起名。白居易字乐天，《礼记·中庸》：“故君子居易以俟命,小人行险以徼幸。”《哀公问》：“不能安土，不能乐天。”安土即居易，故乐天。</p>
      <p>(9) 使典用事</p>
      <p>取材于史传载记，诸子百家之书。李商隐，字义山。《史记·伯夷叔齐列传》：“伯夷、叔齐叩马而谏曰：“父死不葬，爰及干戈，可谓孝乎？以臣弑君，可谓仁乎？”左右欲兵之。太公曰：“此义人也。”扶而去之。武王已平殷乱，天下宗周，而伯夷、叔齐耻之，义不食周粟，隐于首阳山，采薇而食之。”商隐，即谓殷商之隐者，义山，即“隐于首阳山”</p>
      <p>(10) 崇奉宗教</p>
      <p>王维，字摩诘,维摩诘即是佛家菩萨名。</p>
      <p>(11) 离合名字：将名拆开为字。</p>
      <p>王玠，字介玉。</p>
      <p>(12) 采撷名篇</p>
      <p>采用名篇中的警策为名字。夏之蓉，字芙裳。《楚辞·离骚》：“制芰荷以为衣兮，集芙蓉以为裳。不吾知其亦已兮,苟余情其信芳。”</p>
      <p>除上面提到的名、字外，古人还有号，号一般为自己所取或他人所赠，涉及有多种类型，包括：爵号，官号，谥号，庙号，年号，斋号，绰号等，由于号比较随意，就不用太过关注了。</p>
      <p>总之，从上面所述，我们即可发现，古人的字是成人之后的称呼，更像我们现在的名。因此我们可以把这些古人的字整理起来，古为今用。“姓名图谱”小程序中，搜集整理了百万级的古代名人数据，包括其名、字、号等。这些信息为我们起名提供了丰富的素材。说不定就可以找到一个自己喜欢的名字，这些名字可都是古代有学问的名人所用，肯定不会差到哪去。

</p>
      <p></p>
      <p></p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: []
    };
  }
};
</script>

<style scoped lang="scss">
.homeleft {
  .listai {
    .contentImg {
      text-align: center;
      img {
        width: 600px;
      }
      @media screen and(max-width:1200px) {
        img {
          width: 300px;
        }
      }
    }
    @media screen and(max-width:1200px) {
      padding: 0px;
    }
    padding: 16px;
    h1 {
      margin: 30px 0;
      text-align: center;
      @media screen and(max-width:1200px) {
        margin: 10px 0;
      }
    }
    h3 {
      color: #00d2a5;
      // text-align: center;
    }
    h4 {
      font-size: 16px;
      // text-indent: 8px;
    }
    h5 {
      font-size: 15px;
       text-indent: 14px;
    }
    .titleTime {
      height: 80px;
      line-height: 80px;
      border-bottom: 1px #e8eaec solid;
      .titleName {
        color: #00d2a5;
        text-align: center;
      }
    }
    p {
      @media screen and(max-width:1200px) {
        padding: 5px;
      }
      padding: 10px 20px;
      font-size: 15px;
      text-indent: 28px;
      line-height: 28px;
    }
  }
}
</style>
